<template>
  <div class="language-switcher group w-auto">
    <div class="language-switcher__list-item mt-2 pb-1 mr-2">
      <div
        class="language-switcher__list-link cursor-pointer text-primary"
        :class="{ 'color-primary': activeLanguage.active }"
      >
        <span class="language-switcher__list-link-label">
          <i class="fas fa-globe-europe mt-1"></i>
        </span>
      </div>
    </div>
    <div
      class="language-switcher__list hidden group-hover:block bg-gray absolute z-10 p-3"
    >
      <div
        v-for="language in languages"
        :key="language.code"
        class="language-switcher__list-item mt-3"
      >
        <div
          :href="language.url"
          class="language-switcher__list-link cursor-pointer text-black hover:text-primary"
          :class="{ 'text-primary': language.active }"
          @click="switchLanguage(language)"
        >
          <span
            class="language-switcher__list-link-label text-black hover:text-primary"
          >
            {{ language.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LanguageSwitcher",
  data() {
    return {
      languages: [
        {
          label: this.$t("english"),
          code: "en",
          active: false,
        },
        {
          label: this.$t("dutch"),
          code: "nl",
          active: false,
        },
        {
          label: this.$t("french"),
          code: "fr",
          active: false,
        },
      ],
    }
  },
  computed: {
    activeLanguage() {
      return this.languages.find((language) => language.active)
    },
  },
  created() {
    if (window.location.pathname.indexOf("/en") > -1) {
      this.languages[0].active = true
    } else {
      this.languages[1].active = true
    }
  },
  methods: {
    switchLanguage(language) {
      const href = window.location.href
      // if href contains /en or /fr redirect to the same page but with the new language
      if (href.indexOf("/en") > -1) {
        window.location.href = href.replace("/en", `/${language.code}`)
      } else if (href.indexOf("/fr") > -1) {
        window.location.href = href.replace("/fr", `/${language.code}`)
      } else {
        window.location.href = `/${language.code}`
      }
    },
  },
}
</script>

<style scoped>
.language-switcher__list-link {
  margin-top: 8px;
}
</style>
